import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { FormContext, useForm } from 'react-hook-form'
import { Box, Button, Typography, useTheme } from '@material-ui/core'

import { Download as DownloadIcon } from 'react-feather'

import { BaseDialog, FileUploadInput, LoadingFeedback } from 'components'

import helpers from 'helpers'

import useSnackbar from 'hooks/useSnackbar'

import * as service from 'service'
import { getBaseURL } from 'service/env'
import constants from 'constants/index'
import useStyles from './styles'
import schema from './schema'

const ImportDepartmentsDialog = ({ open, setOpen, onImported }) => {
  const [loading, setLoading] = useState(false)

  const formMethods = useForm({
    validationSchema: schema,
    defaultValues: { file: null },
  })

  const { handleSubmit, reset } = formMethods

  const classes = useStyles()
  const theme = useTheme()
  const snackbar = useSnackbar()

  const {
    IMPORT_TEMPLATE_FILE_NAME,
    IMPORT_FILE_TYPE,
    IMPORT_MAX_ROWS,
    IMPORT_MAX_FILE_SIZE_MB,
  } = constants.departments

  const { BYTE_UNIT_EXPONENT } = constants.validations

  const downloadModel = () =>
    window.open(
      `${getBaseURL('dponet')}/${IMPORT_TEMPLATE_FILE_NAME}`,
      '_blank',
    )

  const handleClose = () => {
    reset({ file: null })
    setOpen(false)
  }

  const onSubmit = async ({ file }) => {
    setLoading(true)
    try {
      const response = await service.dponet.departments.importDepartments(file)

      reset({ file: null })
      setOpen(false)
      onImported(response?.data)
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(
            error?.response?.data?.error,
            false,
          ) || 'Ocorreu um erro ao tentar importar os departamentos',
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <BaseDialog
      open={open}
      setOpen={handleClose}
      closeButtonText="Cancelar"
      actionButtonText="Importar"
      formRef="import-departments-form"
      loading={loading}
      title="Importação de Departamentos"
      accentColor={theme.palette.layout.main}
    >
      <LoadingFeedback open={loading} />
      <Box className={classes.box}>
        <Typography align="justify" className={classes.typography}>
          Para importar departamentos, siga o modelo de planilha que
          disponibilizamos (colunas Nome e Descrição). São aceitos arquivos
          .xlsx de até {IMPORT_MAX_FILE_SIZE_MB} MB e {IMPORT_MAX_ROWS} linhas
          por importação. Os departamentos importados são criados sem
          responsável.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={downloadModel}
          className={classes.buttonDownloadModel}
        >
          <DownloadIcon />
          <Typography>Baixar modelo</Typography>
        </Button>
        <FormContext {...formMethods}>
          <form id="import-departments-form" onSubmit={handleSubmit(onSubmit)}>
            <FileUploadInput
              controlName="file"
              title="Arraste e solte ou selecione a planilha com os departamentos a serem importados"
              accept={IMPORT_FILE_TYPE}
              maxSize={IMPORT_MAX_FILE_SIZE_MB * BYTE_UNIT_EXPONENT.MB}
              maxFiles={1}
              loading={loading}
              blockUnaccepted
              highlight
            />
          </form>
        </FormContext>
      </Box>
    </BaseDialog>
  )
}

ImportDepartmentsDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  onImported: PropTypes.func.isRequired,
}

export default ImportDepartmentsDialog
